import { Observable } from 'rxjs';

import { IResponse } from '../global.interface';

export interface IDiscussApi {
    getQuestion: (questionId: number) => Observable<IDiscussPostData>;
    deletePost: (questionId: number) => Observable<object>;
    editPost: (
        id: number,
        message: string,
        tags: string[],
        title: string
    ) => Observable<IDiscussPostData>;
    votePost: (
        questionId: number,
        vote: number
    ) => Observable<IDiscussVoteResponseData>;
    getReplies: (
        questionId: number,
        index: number,
        count: number,
        orderBy: number
    ) => Observable<IDiscussRepliesResponseData>;
    createReply: (
        questionId: number,
        replyContent: string
    ) => Observable<IDiscussAddReplyResponseData>;
    postQuestion: (
        payload: IPostQuestionPayload
    ) => Observable<IDiscussAddReplyResponseData>;
    getTags: (tag: string) => Observable<IGetTagsResponse>;
    discussSearch: (
        options: IDiscussSearchParams
    ) => Observable<DiscussSearchResponseDataType>;
    getDiscussDetails: (
        options: IDiscussSearchParams
    ) => Observable<IDiscussDetailsResponseDataType>;
    toggleAcceptedAnswer: (
        id: number,
        accepted: boolean
    ) => Observable<IDiscussToggleAcceptedAnswerResponseData>;
}

export interface IDiscussSearchParams {
    query: string;
    filter: DiscussSearchFilter;
    index: number;
    count: number;
    profileId?: number;
}

export interface IDiscussReply {
    accessLevel?: number;
    answers?: number;
    avatarUrl?: string;
    avgActionDate?: string;
    badge?: string;
    courseID?: number | null;
    date?: string;
    hasAvatar?: boolean;
    id?: number;
    index?: number;
    isAccepted?: boolean;
    isFollowing?: boolean;
    level?: number;
    message?: string;
    modifyDate?: string | null;
    modifyUserID?: number | null;
    modifyUserName?: string | null;
    ordering?: number;
    parentID?: number;
    tags?: string[];
    title?: string | null;
    userID?: number;
    userName?: string;
    viewCount?: number;
    vote?: number;
    votes?: number;
    xp?: number;
}

export type DiscussSearchResponseDataType = IDiscussQuestionSearchData[];

export interface IDiscussDetailsResponseDataType {
    count: number;
    posts: IDiscussQuestionSearchData[];
}

export interface IDiscussQuestionSearchData {
    answers: number;
    avatarUrl: string;
    badge: string;
    date: string;
    id: number;
    isFollowing: boolean;
    message: string;
    tags: string[];
    title: string;
    userName: string;
    viewCount: number;
    vote: number;
    votes: number;
    hidden: boolean;
    userId: number;
}

export interface IDiscussAddReplyResponseData extends IResponse {
    post: {
        answers: number;
        avgActionDate: null | string;
        courseID: null | number;
        date: string;
        id: number;
        isAccepted: boolean;
        message: string;
        modifyDate: null | 'string';
        modifyUserID: null | 'string';
        ordering: number;
        parentID: number;
        title: null | 'string';
        userID: number;
        viewCount: number;
        votes: number;
    };
}

export interface IGetTagsResponse {
    tags: string[];
}

export interface IPostQuestionPayload {
    title: string;
    message: string;
    tags: string[];
}

export interface IDiscussRepliesResponseData extends IResponse {
    posts: IDiscussReply[];
}

export interface IDiscussToggleAcceptedAnswerResponseData extends IResponse {
    data: number;
}

export interface IDiscussVoteResponseData extends IResponse {
    votes: number;
}

export interface IDiscussPostData extends IResponse {
    post: IDiscussQuestion;
}

export interface IDiscussQuestion {
    accessLevel: number;
    answers: number;
    avatarUrl: string;
    avgActionDate: string;
    badge: string;
    courseID: number | null;
    date: string;
    hasAvatar: boolean;
    id: number;
    index: number;
    isAccepted: boolean;
    isFollowing: boolean;
    level: number;
    message: string;
    modifyDate: string | null;
    modifyUserID: number | null;
    modifyUserName: string | null;
    ordering: number;
    parentID: number;
    tags: string[];
    title: string;
    userID: number;
    userName: string;
    viewCount: number;
    vote: number;
    votes: number;
    xp: number;
    hidden: boolean;
}

export enum DiscussSearchFilter {
    MostRecent = 1,
    MostPopular = 2,
    YourNetwork = 3,
    HotToday = 4,
    Trending = 5,
    OwnData = 6,
    OwnAnswers = 7,
    UnAnswered = 8,
}
